export const constants = {
    FACEBOOK_URL: 'https://www.facebook.com/rtcqc',
    FACEBOOK_PROFILE: 'rtcqc',
    TWITTER_URL: 'https://x.com/rtcquebec',
    TWITTER_HANDLE: 'rtcquebec',
    PHONE_NUMBER: {
        label: '418 627-2511',
        value: '4186272511',
    },
    PHONE_NUMBER_GENERAL: {
        label: '418 627-2511 option 1',
        value: '4186272511,1',
    },
    PHONE_NUMBER_PLAINTE: {
        label: '418 627-2511 option 3',
        value: '4186272511,3',
    },
    SITE_ALIAS: 'rtcquebec.ca',
    CALENDAR_RANGE: process.env.UNLIMITED_CALENDAR === 'true' ? 365 : 31,
    UNLIMITED_CALENDAR: process.env.UNLIMITED_CALENDAR,
    MAP_TILES_STYLE_ENDPOINT: process.env.MAP_TILES_STYLE_ENDPOINT,
    QUEBEC_CITY_BOUNDS: [
        [-71.9318, 46.1632],
        [-70.2034, 47.1603],
    ],
    BASE_URL: process.env.BASE_URL,
};
